import { defineMessages } from 'react-intl';

export default defineMessages({
    language: {
        id: 'gateway.ce.views.preferences.Language',
        defaultMessage: 'Language',
    },
    Preferences: {
        id: 'portal.ce.index.Preferences',
        defaultMessage: 'Preferences',
    },
    accountSettings: {
        id: 'gateway.ce.views.preferences.Account Settings',
        defaultMessage: 'Account Settings'
    }
});
